<template>
    <div>
        <div :class="[(estilosPersonalizados.aplicar) ? '' : 'form-group']" :style="estilosPersonalizados.css">
            <h6 v-if="conDescripcion.estatus">{{ conDescripcion.texto }}</h6>
            <CSelectGenerico class="p-0 m-0"
                v-on:valorParaElPadre="cambioSubmenuHijo" 
                :conEstilosClaros="conEstilosClaros"
                :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                :idDelInput="'SUBMENU-HIJO' + '-VADSM-'+ nodoPrincipal[identificadores.llave]" 
                :valorDefinido="catalogo.valorDefinido"
                :elementos="nodosHijos" 
                :key="'CSRC-' + nodoPrincipal[identificadores.llave] + catalogo.contRender"
                :mansajeValorDefinidoPlural="textoPluralEnSelect" 
                :mansajeValorDefinidoSingular="texoSingularEnSelect"></CSelectGenerico>
        </div>
        <nodoHijo class="mt-2"
            v-if="nodoSeleccionado != null && (nodoSeleccionado[identificadores.nodosHijos] != undefined && nodoSeleccionado[identificadores.nodosHijos].length > 0)"
            :conDescripcion="conDescripcion"
            :nodoPrincipal="nodoSeleccionado"
            :identificadores="identificadores"
            v-on:SeleccionoElemento="evtSeleccionDeHijo"
            :texoSingularEnSelect="texoSingularEnSelect"
            :textoPluralEnSelect="textoPluralEnSelect"></nodoHijo>
    </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import CSelectGenerico from '@/components/SICPO/Comun/CSelectGenerico.vue'

export default {
    name: 'nodoHijo',
    props: {
        nodoPrincipal: Object,
        /* formato { 
                nodosHijos: 'Nombre de atributo de la lista de objetos', 
                llave: nombre del atributo id de los objetos para las opciones del select, 
                nombre: nombre del taributo para el label de la opcion para las opciones del select */
        identificadores: Object,
        texoSingularEnSelect: String,
        textoPluralEnSelect: {
            type: String,
            default: 'los elementos'
        },
        conDescripcion: {
            type: Object,
            // formato = { estatus: mostrar o no, texto: texto que se mostrara }
            default: () => ({ estatus: false, texto: null })
        },
        estilosPersonalizados: {
            type: Object,
            // formato = { aplicar: booleano para indicar aplicacion, css: estilos }
            default: () => ({ aplicar: false, css: null })
        },
        conEstilosClaros: {
          type: Boolean,
          default: false
      },
    },
    components: {
        CSelectGenerico: CSelectGenerico
    },
    data() {
        return {
            enumeraciones,
            nodosHijosObj: [],
            nodoSeleccionado: null,
            nodoSeleccionadoHijo: null,
            catalogo: {
                valorDefinido: -1,
                contRender: 0
            }
        }
    },
    methods: {
        evtSeleccionDeHijo: function(evento, objetoElemento) {
            this.$emit('SeleccionoElemento',evento,objetoElemento);
        },
        cambioSubmenuHijo: function(evento, objetoElemento) {
            this.nodoSeleccionado = (objetoElemento != null && objetoElemento != undefined) ? objetoElemento.objetoNodo : null;
            console.log('el::',this.nodoSeleccionado);
            this.$emit('SeleccionoElemento',evento,this.nodoSeleccionado);
        },
        actualizarElementosDeCatalogo: function() {
            if(this.nodoPrincipal != null && this.nodoPrincipal != undefined) {
                this.nodosHijosObj = this.nodoPrincipal[this.identificadores.nodosHijos].map(np => {
                    let objNodoSelect = {};
                    objNodoSelect.valor = np[this.identificadores.llave];
                    objNodoSelect.nombre = np[this.identificadores.nombre];
                    objNodoSelect.objetoNodo = np;
                    return objNodoSelect;
                });
            }
            console.log('created::recursivo::',this.nodosHijosObj);
        }
    },
    created() {
        this.actualizarElementosDeCatalogo();
    },
    computed: {
        nodosHijos() {
            return this.nodosHijosObj;
        }
    },
    watch: {
        nodoPrincipal() {
            this.actualizarElementosDeCatalogo();
            this.nodoSeleccionado = null;
        }
    }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/SICPO/Comun/CSelectRecursivo.vue